import React, { useRef, useState } from 'react'
import { Button, Dropdown, Form, InputGroup, Modal } from 'react-bootstrap'
import { AD_BANNER_STATUS } from '..'
import Cookies from 'js-cookie'
import config from '../../../config'
import Swal from 'sweetalert2'
import { useDispatch } from 'react-redux'
import { getPublicUrl, getUploadImageUrl } from '../../../helpers/url'

const CreateCampaignModal = ({ show, selectedAdBanner, handleCloseModal, onCreatedAdBanner }) => {
  const [adBannerData, setAdBannerData] = useState({
    url: selectedAdBanner?.redirectUrl?.url ?? '',
    images: selectedAdBanner?.images ?? [],
    status: AD_BANNER_STATUS.ACTIVE,
  })
  const imageInputRef = useRef(null)
  const dispatch = useDispatch()

  const imageSize = {
    WEB: { width: 1000, height: 150 },
    MOBILE: { width: 1200, height: 349 },
  }

  const handleUpdateValue = (key, value) => {
    setAdBannerData({ ...adBannerData, [key]: value })
  }

  const handleUploadImage = async (event, type) => {
    const file = event.target.files[0]
    const imageType = type === 'WEB' ? 1 : 2

    if (!file) {
      return setAdBannerData({
        ...adBannerData,
        images: [...adBannerData.images.filter((image) => image.type !== type || image.type === imageType)],
      })
    }

    const { width, height } = imageSize[type]

    const img = new Image()
    img.src = URL.createObjectURL(file)
    img.onload = async () => {
      if (img.height <= height && img.width <= width) {
        try {
          dispatch({ type: 'loading_show' })

          const url = await getUploadImageUrl()
          const imageUrl = getPublicUrl(url)

          const response = await fetch(url, {
            method: 'PUT',
            body: file,
          })

          if (!response.ok) throw new Error('Error uploading image')

          const image = {
            url: imageUrl,
            type: type === 'WEB' ? 1 : 2,
          }

          if (adBannerData.images.find((i) => i.type === type || i.type === imageType)) {
            const images = adBannerData.images.map((i) => (i.type === type || i.type === imageType ? image : i))

            return setAdBannerData((prevData) => ({
              ...prevData,
              images: images,
            }))
          }

          return setAdBannerData((prevData) => ({
            ...prevData,
            images: [...(prevData.images || []), image],
          }))
        } catch (error) {
          console.error(error)
          if (imageInputRef.current) {
            imageInputRef.current.value = null
          }

          Swal.fire({
            title: 'ไม่สามารถเพิ่มรูปภาพได้',
            html: 'กรุณาตรวจสอบขนาดไฟล์และ<br>นามสกุลไฟล์ที่รองรับ',
            icon: 'error',
          })
        } finally {
          dispatch({ type: 'loading_hide' })
        }
      } else {
        Swal.fire({
          title: 'เกิดข้อผิดพลาดในการอัพโหลดรูปภาพ',
          text: `เนื่องจากรูปภาพมีขนาดเกิน ${width} x ${height} `,
          icon: 'error',
        })
      }
    }
  }

  const handleCreateAdBanner = async () => {
    if (adBannerData.images.length < 2) {
      return Swal.fire({
        title: 'กรุณาอัปโหลดรูปภาพทุกขนาด',
      })
    }

    if (adBannerData.images.length !== 2) {
      return Swal.fire({
        title: 'กรุณาอัปโหลดขนาดละหนึ่งรูปภาพ',
      })
    }

    try {
      dispatch({ type: 'loading_show' })

      let response
      response = await fetch(
        `${config.apiAdminGateway}/api/v1/admin/configs/banners${
          selectedAdBanner?.id ? `/${selectedAdBanner?.id}` : ''
        } `,
        {
          method: `${selectedAdBanner?.id ? 'PUT' : 'POST'}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
          body: JSON.stringify({
            images: adBannerData.images,
            status: adBannerData.status,
            redirectUrl: {
              name: adBannerData.url,
              url: adBannerData.url,
            },
          }),
        },
      ).then((response) => response.json())

      if (response.status.code !== 0) {
        throw new Error('Error creating AdBanner')
      }

      Swal.fire({
        title: selectedAdBanner?.id ? 'อัปเดตแบนเนอร์สำเร็จ' : 'สร้างแบนเนอร์สำเร็จ',
        icon: 'success',
      }).then(() => {
        onCreatedAdBanner()
      })
    } catch (error) {
      console.error(error)
      Swal.fire({
        title: 'เกิดข้อผิดพลาด',
        text: 'ตรวจสอบข้อมูลและลองใหม่อีกครั้ง',
        icon: 'error',
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  return (
    <Modal show={show} onHide={handleCloseModal} size="lg">
      <Modal.Header>
        <Modal.Title>สร้างแบนเนอร์</Modal.Title>
        <Button variant="" className="close" onClick={handleCloseModal}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form className="">
          <Form.Label>Link</Form.Label>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text id="basic-addon2">https://</InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              placeholder="กรอกลิ้งค์"
              value={adBannerData.url}
              onChange={(e) => {
                const text = e.target.value
                handleUpdateValue('url', text)
              }}
            />
          </InputGroup>
          <Form.Row className="mb-2 flex-column">
            <Form.Label>สถานะ</Form.Label>
            <Dropdown>
              <Dropdown.Toggle className="primary light" id="dropdown-autoclose-outside">
                {adBannerData.status}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {Object.values(AD_BANNER_STATUS).map((status) => (
                  <Dropdown.Item onClick={() => handleUpdateValue('status', status)} key={status} value={status}>
                    {status}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Group>
              <Form.Label>
                รูปภาพ (Mobile)
                <span style={{ color: 'rgb(225,0,0)', fontSize: '12px', paddingLeft: '2px' }}>
                  (เฉพาะไฟล์ .jpg หรือ .jpeg และขนาดต้องไม่เกิน {imageSize.MOBILE.width} X {imageSize.MOBILE.height})
                </span>
              </Form.Label>
              <Form.Control
                type="file"
                ref={imageInputRef}
                onChange={(e) => handleUploadImage(e, 'MOBILE')}
                accept="image/jpg,image/jpeg"
              />
            </Form.Group>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Group>
              <Form.Label>
                รูปภาพ (Desktop)
                <span style={{ color: 'rgb(225,0,0)', fontSize: '12px', paddingLeft: '2px' }}>
                  (เฉพาะไฟล์ .jpg หรือ .jpeg และขนาดต้องไม่เกิน {imageSize.WEB.width} X {imageSize.WEB.height})
                </span>
              </Form.Label>
              <Form.Control
                type="file"
                ref={imageInputRef}
                onChange={(e) => handleUploadImage(e, 'WEB')}
                accept="image/jpg,image/jpeg"
              />
            </Form.Group>
          </Form.Row>
          <Form.Row className="mb-2">
            {adBannerData?.images.length > 0 &&
              adBannerData?.images.map((image) => (
                <div className="mb-2">
                  {image.type === 2 || image.type === 'MOBILE' ? 'Mobile' : 'Desktop'}
                  <img width="100%" alt="upload preview" src={image?.url} />
                </div>
              ))}
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={handleCloseModal}>
          ยกเลิก
        </Button>
        <Button variant="primary light" onClick={handleCreateAdBanner}>
          ยืนยัน
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateCampaignModal
